import {Component, Input, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {GtAuthenticationService} from '@app/services/gt-authentication.service';
import {GtDirectoryService} from '@app/services/gt-directory.service';
import {GtPhoneNumberUtil} from '@app/shared/utils/gt-phone-number.util';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'gt-click2call',
  templateUrl: './click2call.component.html',
  styleUrls: ['./click2call.component.scss']
})
export class Click2callComponent implements OnInit {
  phoneNumber: string;
  initialPhoneNumber: string;
  displayNumber: string;
  name: string;
  message: string;
  @Input() canEdit = true;

  constructor(
    private authenticationService: GtAuthenticationService,
    private dialogRef: MatDialogRef<Click2callComponent>,
    private directoryService: GtDirectoryService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    if (this.initialPhoneNumber) {
      this.phoneNumber = this.initialPhoneNumber;
    }
    if (this.name && this.name !== '') {
      this.message = this.translate.instant('click2call.header_to', {name: this.name});
    } else {
      this.message = this.translate.instant('click2call.header');
    }
  }

  displayNumberChanged(displayNumber: string) {
    this.displayNumber = displayNumber;
  }

  okClicked(event?: string) {
    if (this.phoneNumber && this.phoneNumber.length) {
      this.directoryService.getContactByShortNumber(this.authenticationService.oname, this.phoneNumber).subscribe(contact => {
        if (contact) {
          this.phoneNumber = contact.phoneNumber;
        }
        this.dialogRef.close({phoneNumber: GtPhoneNumberUtil.toBackend(this.phoneNumber), displayNumber: this.displayNumber});
      });
    }
  }

  cancelClicked() {
    this.dialogRef.close();
  }

  setPhoneNumber(fullNumber: string) {
    this.phoneNumber = GtPhoneNumberUtil.toDisplay(fullNumber);
  }
}
